import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { ROUTE_DISCOVER, ROUTE_ANALYSE_OVERVIEW, ROUTE_TIPS } from 'RouteList';
import BasePage from 'components/BasePage/BasePage';
import Content from 'components/BasePage/Content';
import Button from 'components/Button/Button';
import { Flex } from 'components/Layout/Layout';
import { useStores } from '../../store/useStores';

function Home() {
  const { routing } = useStores();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { push } = routing;

  return (
    <BasePage>
      <Content verticalcenter>
        <Flex mb={4} width={1}>
          <Button full primary onClick={() => push(ROUTE_DISCOVER)}>
            <FormattedMessage {...messages.homeDiscover} />
          </Button>
        </Flex>
        <Flex mb={4} width={1}>
          <Button full primary onClick={() => push(ROUTE_ANALYSE_OVERVIEW)}>
            <FormattedMessage {...messages.homeAnalyse} />
          </Button>
        </Flex>
        <Flex mb={4} width={1}>
          <Button full primary onClick={() => push(ROUTE_TIPS)}>
            <FormattedMessage {...messages.homeTips} />
          </Button>
        </Flex>
      </Content>
    </BasePage>
  );
}

export default observer(Home);
